var _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXmasSanta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 78,
    viewBox: "0 0 68 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.31809 23.832C12.8046 5.70333 59.5848 13.5225 58.7786 32.7295C57.9724 51.9365 3.83153 41.9606 8.31809 23.832Z",
    fill: "#DD4932",
    stroke: "black",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7479 32.0011C22.4227 19.4397 44.9471 22.8955 53.7019 39.5751C44.2338 46.9353 18.0345 41.8857 10.7479 32.0011Z",
    fill: "#F5CDAF",
    stroke: "black",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00974 49.9089C2.79121 42.9818 7.86143 35.3619 10.6739 32.4178C18.9914 43.7743 44.3808 46.1012 54.4621 40.1389C56.8137 46.9227 58.3151 52.428 53.8023 58.5123C41.4405 70.0924 25.6186 72.0325 25.6186 72.0325C19.6734 67.5443 7.22826 56.836 5.00974 49.9089Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.974 6.99925C32.6475 2.40913 18.0542 10.0698 14.5213 15.4668C34.686 10.8522 48.9143 15.5113 58.8251 27.5787C62.1119 26.0085 57.6707 17.0552 57.6707 17.0552C54.6034 10.0645 46.974 6.99925 46.974 6.99925Z",
    fill: "#DD4932",
    stroke: "black",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 59.4388,
    cy: 21.6667,
    r: 4.42847,
    transform: "rotate(10 59.4388 21.6667)",
    fill: "white",
    stroke: "black",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.4406,
    cy: 31.5818,
    r: 2.96424,
    transform: "rotate(10 25.4406 31.5818)",
    fill: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.4543,
    cy: 34.229,
    r: 2.96424,
    transform: "rotate(10 40.4543 34.229)",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5492 40.4204C36.3951 41.2945 35.637 42.2792 34.374 43.0204C33.1275 43.7519 31.6908 44.0605 30.5849 43.8655C29.4791 43.6705 28.2346 42.8891 27.3134 41.7754C26.3801 40.647 26.0045 39.4624 26.1587 38.5883C26.3128 37.7141 27.0708 36.7294 28.3338 35.9882C29.5804 35.2568 31.0171 34.9481 32.1229 35.1431C33.2288 35.3381 34.4733 36.1195 35.3945 37.2332C36.3278 38.3617 36.7033 39.5463 36.5492 40.4204Z",
    fill: "#DD4932",
    stroke: "black",
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4033 42.9655C16.4317 46.9064 22.3575 52.9679 29.8334 45.6862C36.2862 55.4242 43.4976 51.1059 46.0975 48.554",
    stroke: "black",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXmasSanta);
export default __webpack_public_path__ + "static/media/xmas-santa.5d0b3687cac23d045cef866553e80dc2.svg";
export { ForwardRef as ReactComponent };